import { Component, ContentChildren, ElementRef, OnInit, QueryList, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";
import {NgxSpinnerService} from "ngx-spinner";
import Me from "../helpers/me";
import App from "../helpers/app";
import Api from "../helpers/api";
import {take} from "rxjs/operators";
import * as moment from 'moment'
import * as pdfMake from "pdfmake/build/pdfmake";  
import { MatriculaServidorHelper } from "../shared/services/matricula-servidor.helper";
import { prepararCamposData, prepararDataParaApi } from "../helpers/date.helper";
import * as pdfFonts from "pdfmake/build/vfs_fonts";  
declare var require: any;
const htmlToPdfmake = require("html-to-pdfmake");
(<any>pdfMake).vfs = pdfFonts.pdfMake.vfs;
import {Subject, Observable} from 'rxjs';
import { WebcamImage, WebcamUtil } from 'ngx-webcam';

@Component({
  selector: 'app-servidor',
  templateUrl: './servidor.component.html',
  styleUrls: ['./servidor.component.scss']
})
export class ServidorComponent implements OnInit {
  accounts = [
    { name: 'Adam', email: 'adam@email.com', age: 12, country: 'United States', child: { state: 'Active' } },
    { name: 'Homer', email: 'homer@email.com', age: 47, country: '', child: { state: 'Active' } },
    { name: 'Samantha', email: 'samantha@email.com', age: 30, country: 'United States', child: { state: 'Active' } },
    { name: 'Amalie', email: 'amalie@email.com', age: 12, country: 'Argentina', child: { state: 'Active' } },
    { name: 'Estefanía', email: 'estefania@email.com', age: 21, country: 'Argentina', child: { state: 'Active' } },
    { name: 'Adrian', email: 'adrian@email.com', age: 21, country: 'Ecuador', child: { state: 'Active' } },
    { name: 'Wladimir', email: 'wladimir@email.com', age: 30, country: 'Ecuador', child: { state: 'Inactive' } },
    { name: 'Natasha', email: 'natasha@email.com', age: 54, country: 'Ecuador', child: { state: 'Inactive' } },
    { name: 'Nicole', email: 'nicole@email.com', age: 43, country: 'Colombia', child: { state: 'Inactive' } },
    { name: 'Michael', email: 'michael@email.com', age: 15, country: 'Colombia', child: { state: 'Inactive' } },
    { name: 'Nicolás', email: 'nicole@email.com', age: 43, country: 'Colombia', child: { state: 'Inactive' } }
];
@ViewChild('comprovante')
modalComprovante: TemplateRef<any>;


@ViewChild('modalcomprovante', { static: true }) teste: TemplateRef<any>;


  tiposaposentadoria = [
    { name: 'Aposentadoria por Idade', value: 1, group: 'Para Civis' },
    { name: 'Aposentadoria por Tempo de Contribuição', value: 2, group: 'Para Civis' },
    { name: 'Aposentadoria por tempo de contribuição e idade', value: 10, group: 'Para Civis' },
    { name: 'Aposentadoria Compulsória', value: 3, group: 'Para Civis' },
    { name: 'Aposentadoria por Invalidez', value: 4, group: 'Para Civis' },
    { name: 'Aposentadoria como Professor', value: 5, group: 'Para Civis' },
    { name: 'Aposentadoria Especial - atividade de risco (Art. 40, § 4o, inc. II, CF)', value: 6, group: 'Para Civis' },
    { name: 'Aposentadoria Especial - atividade prejudiciais à saúde ou integridade física (Art. 40, § 4o, inc. III, CF)', value: 7, group: 'Para Civis' },
    { name: 'Militares Inativos - Reserva Remunerada', value: 8, group: 'Militares Inativos' },
    { name: 'Militares Inativos - Reforma', value: 9, group: 'Militares Inativos' }
  ]
  tipospensao = [
    { name: 'Vitalícia', value: 1 },
    { name: 'Temporária', value: 2 },
  ]
  sexos = [

    {
      id: 'M',
      name: 'Masculino',
    },{
      id: 'F',
      name: 'Feminino',
    }]
  naturalizados = [
    {
      id: 1,
      name: 'Sim',
    },{
      id: 2,
      name: 'Não',
    }
  ]

    statusServidor = [
      {
        id: 1,
        name: 'Ativo',
      },{
        id: 2,
        name: 'Aposentado',
      },{
        id: 3,
        name: 'Pensionista',
      },{
        id: 4,
        name: 'Exonerado',
      },{
        id: 5,
        name: 'Falecido',
      }
    ]
    tipoFundo = [
      "Fundo em Capitalização",
      "Fundo em Repartição",
      "Mantidos pelo Tesouro"
    ]
    tipoVinculo = [
      "Civil",
      "Militar"
    ]
    relacaoTitularPensao = [
      {
        id: 1,
        name: 'Cônjuge',
      },{
        id: 2,
        name: 'Filho menor de 21 anos',
      },{
        id: 3,
        name: 'Filho inválido ou com deficiência',
      },{
        id: 4,
        name: 'Pais',
      },{
        id: 5,
        name: 'Irmão',
      },{
        id: 6,
        name: 'Outros',
      }
    ]

  apiCall = this.api.new().silent();
  estados = [];
  cidades = [];
  orgaos = [];
  estadosCivis = [];
  statusAgenda = [];
  agenda = "";
  oldStatus;
  escolaridades = [];
  servidor
  idServidor
  idCidade
  idMatricula
  urlToShow = null
  hasDadosBancarios = false
  idCenso = null
  arquivosFlax: any[] = []
  idTipoAlteracao = null
  justificativa = null
  constructor(
    private router: Router,
    private modalService: NgbModal,
    private spinner: NgxSpinnerService,
    private route: ActivatedRoute,
    private me: Me,
    private app: App,
    private api: Api
  ) {
  }

  async ngOnInit(){
    const self = this
    self.estados = [];
    self.cidades = [];
    self.orgaos = [];
    self.estadosCivis = [];
    self.statusAgenda = [
      { id: 1, descricao: 'Reunião Não Agendada' },
      { id: 2, descricao: 'Reunião Agendada' },
      { id: 3, descricao: 'Reunião Realizada' },
      // Outras opções...
    ];
    self.escolaridades = [];
    self.servidor = null
    self.idServidor = null
    self.idCenso = null
    self.arquivosFlax = []
    this.route.queryParams.subscribe( parametros => {
      if (parametros['id']) {
        this.idServidor = parametros['id'];
      }
      if (parametros['idCidade']) this.idCidade = parametros['idCidade'];
      if (parametros['id_matricula']) this.idMatricula = parametros['id_matricula'];
      if (parametros['id_censo']) this.idCenso = parametros['id_censo'];
      if (parametros['id_tipo_alteracao']) this.idTipoAlteracao = parametros['id_tipo_alteracao'];
      if (parametros['justificativa']) this.justificativa = parametros['justificativa'];
    });
    self.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    const dadosUsuario = self.me.currentUserValue;
    const json = JSON.parse(JSON.stringify(dadosUsuario));
    if (!self.idCidade) self.idCidade = json.user.cidade
    const estados = await self.apiCall.get('enderecos/estados').pipe(take(1)).toPromise()
    self.estados = JSON.parse(JSON.stringify(estados));
    const escolaridades = await self.apiCall.get('servidor/escolaridade').pipe(take(1)).toPromise()
    self.escolaridades = JSON.parse(JSON.stringify(escolaridades));
    const estadosCivis = await self.apiCall.get('servidor/estadocivil').pipe(take(1)).toPromise()
    self.estadosCivis = JSON.parse(JSON.stringify(estadosCivis));
    const servidor = await self.apiCall.get(`servidor?id=${self.idServidor}&id_cidade=${self.idCidade}${self.idCenso ? `&id_censo=${self.idCenso}` : ''}${self.idMatricula ? `&id_matricula=${self.idMatricula}` : ''}`).pipe(take(1)).toPromise()
    self.servidor = MatriculaServidorHelper.normalizarServidor(
      JSON.parse(JSON.stringify(servidor)),
      self.idCidade,
      self.idMatricula
    );
    self.idMatricula = self.servidor.id_matricula;
    self.oldStatus = self.servidor.status;
    if (self.idCenso) {
      const arquivosFlax = await self.apiCall
        .get(`censo/${self.idCenso}/servidores/${self.idServidor}/arquivos-flax`)
        .pipe(take(1))
        .toPromise();
      self.arquivosFlax = Array.isArray(arquivosFlax)
        ? JSON.parse(JSON.stringify(arquivosFlax))
        : [];
    }
    const cidades = await this.apiCall.get('enderecos/estados/cidades?estado='+self.servidor.estado_naturalidade).pipe(take(1)).toPromise()
    self.cidades = JSON.parse(JSON.stringify(cidades));
    const bancario = await self.apiCall.get(`servidor/dadosbancarios?id_servidor=${self.idServidor}`).pipe(take(1)).toPromise()
    if(bancario) self.hasDadosBancarios = true
    const orgaos = await self.apiCall.get('enderecos/estados/cidades/orgaos/todos?cidade='+self.idCidade).pipe(take(1)).toPromise()
    self.orgaos = JSON.parse(JSON.stringify(orgaos));
    this.servidor.agenda = this.statusAgenda.find(item => item.descricao === servidor.agenda)?.id;
    self.spinner.hide()
    if(self.servidor.cidade_naturalidade) self.servidor.cidade_naturalidade = +self.servidor.cidade_naturalidade
    if(this.servidor.valor_aposentadoria && this.servidor.valor_aposentadoria.toFixed(2)) this.servidor.valor_aposentadoria = this.servidor.valor_aposentadoria.toFixed(2).toString().replace('.', ',')
    if(this.servidor.valor_beneficio && this.servidor.valor_beneficio.toFixed(2)) this.servidor.valor_beneficio = this.servidor.valor_beneficio.toFixed(2).toString().replace('.', ',')
    if(this.servidor.data_nascimento && moment(this.servidor.data_nascimento, 'DDMMYYYY') ) this.servidor.idade = moment().diff(moment(this.servidor.data_nascimento, 'DDMMYYYY'), 'years')
    if(this.servidor.data_ingresso_servico_publico && moment(this.servidor.data_ingresso_servico_publico) ) this.servidor.data_ingresso_servico_publico = moment(this.servidor.data_ingresso_servico_publico).format('DD/MM/YYYY')
    if(this.servidor.inicio_atendimento && this.servidor.fim_atendimento) this.servidor.atendimento =  moment.utc(moment(this.servidor.fim_atendimento).diff(moment(this.servidor.inicio_atendimento))).format('[Tempo de atendimento]: HH [horas] : mm [minutos] : ss [segundos]')
    self.servidor.motivo_exoneracao = this.servidor.motivo_exoneracao;
  }

  updateAgendaStatus(value) {
    this.servidor.agenda = this.statusAgenda.find(item => item.descricao === value.descricao)?.id;
  }
  async toggleEstado(){
    this.cidades = []
    const cidades = await this.apiCall.get('enderecos/estados/cidades?estado='+this.servidor.estado_naturalidade).pipe(take(1)).toPromise()
    this.cidades = JSON.parse(JSON.stringify(cidades));
  }
  async postFile(extension, type){
    const response = await this.apiCall.post(`servidor/arquivo/url`, {extension : extension, type: type}).pipe(take(1)).toPromise();
    if(response.result){
      return response.result
    }else{
      return null
    }
  }

  async salvarImagemServidor(imagem: string) {
    if (!this.servidor || !this.servidor.id) {
      return;
    }

    await this.apiCall.get(
      `servidor/editar/imagem?id=${this.servidor.id}&id_cidade=${this.idCidade}&imagem=${encodeURIComponent(imagem)}`
    ).pipe(take(1)).toPromise();
    this.servidor.imagem = imagem;
    await this.app.alert('Tudo certo!', 'Foto atualizada com sucesso!', 'success');
    await this.ngOnInit();
  }

  public downloadAsPDF() {
    const modalComprovante = this.modalComprovante.elementRef.nativeElement;

    var html = htmlToPdfmake(modalComprovante.innerHTML);
    
    const documentDefinition = { content: html };
    pdfMake.createPdf(documentDefinition).download(); 
     
  }

  multipleNavigate(content){
    this.modalService.open(content, { centered: true });
  }
  multipleWebcamsAvailable = false
  openModalCamera(content){
    const slef = this
    WebcamUtil.getAvailableVideoInputs()
      .then((mediaDevices: MediaDeviceInfo[]) => {
        this.multipleWebcamsAvailable = mediaDevices && mediaDevices.length > 1;
        this.modalService.open(content, { centered: true });

      });
  }
  openModal(content){
    this.modalService.open(content, { centered: true, size: 'xl' });
  }
  fileNameAndExt(str){
    var file = str.split('/').pop();
    return [file.substr(0,file.lastIndexOf('.')),file.substr(file.lastIndexOf('.')+1,file.length)]
  }
  viewMidia(urlToShow, content){
    this.urlToShow = urlToShow
    this.modalService.open(content, { centered: true });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });    
    return blob;
 }
 
  async uploadImage(event){
    console.log('veiooo')
    const self = this
    const file = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = async  () => {
      if(file.size>2000000){
        await this.app.alert(`Atenção`, `o tamanho do arquivo não pode ser maior que 2mb!`, `error`)
        return
      }
      if(file && self.fileNameAndExt(file.name)[1]) {
        try{
          self.spinner.show(undefined,
            {
              type: 'ball-triangle-path',
              size: 'medium',
              bdColor: 'rgba(0, 0, 0, 0.8)',
              color: '#fff',
              fullScreen: true
            });
                    const urlToPostFile = await self.postFile(self.fileNameAndExt(file.name)[1], file.type);
  
          if(!urlToPostFile){
            return
          }
  
          var optionsFile = { headers: { 'Content-Type': file.type, 'x-amz-acl': 'public-read' } };
  
          const uploadFile = await self.api.http.put(urlToPostFile, file, optionsFile).toPromise()
  
          const locationFile = urlToPostFile.toString().split('?',1)[0]

          if (locationFile) {
            await self.salvarImagemServidor(locationFile);
          }
          console.log(locationFile)
          self.spinner.hide()
        }catch(e){
          self.spinner.hide()
        }
      }
    };
    reader.onabort = () => {
    };
    reader.onerror = () => {
    };

  }

  private trigger: Subject<void> = new Subject<void>();
  public webcamImage: WebcamImage = null;  
  public triggerSnapshot(): void {
    this.trigger.next();

  }
  async handleImage(webcamImage: WebcamImage, modal) {
    const self = this
    let file = this.dataURItoBlob(webcamImage.imageAsBase64)
    modal.close("Close click");
    this.webcamImage = webcamImage;
    try{
      self.spinner.show(undefined,
        {
          type: 'ball-triangle-path',
          size: 'medium',
          bdColor: 'rgba(0, 0, 0, 0.8)',
          color: '#fff',
          fullScreen: true
        });
                const urlToPostFile = await self.postFile('jpeg', 'image/jpeg');

      if(!urlToPostFile){
        return
      }

      var optionsFile = { headers: { 'Content-Type': 'image/jpeg', 'x-amz-acl': 'public-read' } };

      const uploadFile = await self.api.http.put(urlToPostFile, file, optionsFile).toPromise()

      const locationFile = urlToPostFile.toString().split('?',1)[0]

      if (locationFile) {
        await self.salvarImagemServidor(locationFile);
      }
      console.log(locationFile)
      self.spinner.hide()
    }catch(e){
      self.spinner.hide()
    }
  }
  public get triggerObservable(): Observable<void> {
    return this.trigger.asObservable();
  }
  disableServidor() {
    const self = this;
    return false
    if (self.servidor.status && self.servidor.status == 1) {
      if (
        !self.servidor.nome ||
        !self.servidor.status ||
        !self.servidor.deficiente ||
        !self.servidor.escolaridade ||
        !self.servidor.nome_mae ||
        !self.servidor.nome_pai ||
        !self.servidor.naturalizado ||
        !self.servidor.nacionalidade ||
        !self.servidor.cidade_naturalidade ||
        !self.servidor.estado_civil ||
        !self.servidor.sexo ||
        !self.servidor.estado_naturalidade ||
        !self.servidor.data_nascimento ||
        !self.servidor.orgao
      ) {
        return true;
      } else {
        return false;
      }
    }
    if (self.servidor.status && self.servidor.status == 2) {
      if (
        !self.servidor.nome ||
        !self.servidor.status ||
        !self.servidor.deficiente ||
        !self.servidor.escolaridade ||
        !self.servidor.nome_mae ||
        !self.servidor.nome_pai ||
        !self.servidor.naturalizado ||
        !self.servidor.nacionalidade ||
        !self.servidor.cidade_naturalidade ||
        //!self.servidor.orgao ||
        !self.servidor.estado_civil ||
        !self.servidor.sexo ||
        !self.servidor.estado_naturalidade ||
        !self.servidor.data_nascimento ||
        !self.servidor.orgao
      ) {
        return true;
      } else {
        return false;
      }
    } else if (self.servidor.status) {
      if (
       (self.servidor.status==3 && !self.servidor.cpf_pensao) ||
       (self.servidor.status==3 && !self.servidor.nome_pensao) ||
       //(self.servidor.status==3 && !self.servidor.orgao) ||
        !self.servidor.nome ||
        !self.servidor.status ||
        !self.servidor.deficiente ||
        !self.servidor.escolaridade ||
        !self.servidor.nome_mae ||
        !self.servidor.nome_pai ||
        !self.servidor.naturalizado ||
        !self.servidor.nacionalidade ||
        !self.servidor.cidade_naturalidade ||
        !self.servidor.estado_civil ||
        !self.servidor.sexo ||
        !self.servidor.estado_naturalidade ||
        !self.servidor.data_nascimento
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }
  async editarServidor() {
    const self = this;

    if (!self.servidor || !self.servidor.id) {
        return;
    }

    if (!self.idMatricula || !self.idCidade) {
        await this.app.alert('Erro', 'Selecione uma matrícula para atualizar o servidor.', 'error');
        return;
    }

    // Verificação adicional para status falecido e data de falecimento nula
    if (self.servidor.status === 5 && !self.servidor.data_falecimento) {
        await this.app.alert('Erro', 'Data de falecimento deve ser preenchida para servidores falecidos.', 'error');
        return;
    }

    self.spinner.show(undefined, {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
    });

    const dadosServidor = prepararCamposData(self.servidor, [
      'data_nascimento',
      'data_falecimento',
      'data_ingresso_servico_publico',
      'concessao_aposentadoria',
      'data_falecimento_pensao',
      'data_nascimento_pensao'
    ]);

    dadosServidor.imagem = self.servidor.imagem || '';
    dadosServidor.pendencias =
      !self.servidor.pendencias || self.servidor.pendencias == 'null'
        ? ''
        : self.servidor.pendencias;
    dadosServidor.observacoes =
      !self.servidor.observacoes || self.servidor.observacoes == 'null'
        ? ''
        : self.servidor.observacoes;

    if (dadosServidor.valor_aposentadoria) {
      dadosServidor.valor_aposentadoria = dadosServidor.valor_aposentadoria
        .toString()
        .replace('.', '')
        .replace(',', '.');
    }
    if (dadosServidor.valor_beneficio) {
      dadosServidor.valor_beneficio = dadosServidor.valor_beneficio
        .toString()
        .replace('.', '')
        .replace(',', '.');
    }

    dadosServidor.agenda = this.statusAgenda.find(
      item => item.id === self.servidor.agenda
    )?.descricao;

    await this.apiCall.get('servidor/editar', {
      id: dadosServidor.id,
      id_matricula: self.idMatricula,
      id_cidade: self.idCidade,
      matricula: dadosServidor.matricula,
      nome: this.validateQuotes(dadosServidor.nome),
      estado_civil: dadosServidor.estado_civil,
      pendencias: dadosServidor.pendencias,
      observacoes: dadosServidor.observacoes,
      motivo_exoneracao: dadosServidor.motivo_exoneracao,
      status: dadosServidor.status,
      data_nascimento: dadosServidor.data_nascimento,
      data_falecimento: dadosServidor.data_falecimento,
      nacionalidade: dadosServidor.nacionalidade,
      estado_naturalidade: dadosServidor.estado_naturalidade,
      cidade_naturalidade: dadosServidor.cidade_naturalidade,
      naturalizado: dadosServidor.naturalizado,
      escolaridade: dadosServidor.escolaridade,
      sexo: dadosServidor.sexo,
      nome_mae: this.validateQuotes(dadosServidor.nome_mae),
      nome_pai: this.validateQuotes(dadosServidor.nome_pai),
      data_ingresso_servico_publico: dadosServidor.data_ingresso_servico_publico,
      deficiente: dadosServidor.deficiente,
      imagem: dadosServidor.imagem,
      documento_ingresso_servico_publico:
        dadosServidor.documento_ingresso_servico_publico,
      paridade_aposentadoria: dadosServidor.paridade_aposentadoria,
      concessao_aposentadoria: dadosServidor.concessao_aposentadoria,
      valor_aposentadoria: dadosServidor.valor_aposentadoria,
      cargo_aposentadoria: dadosServidor.cargo_aposentadoria,
      pis_aposentado: dadosServidor.pis_aposentado,
      tipo_aposentadoria: dadosServidor.tipo_aposentadoria,
      cpf_pensao: dadosServidor.cpf_pensao,
      pis_pensao: dadosServidor.pis_pensao,
      nome_pensao: dadosServidor.nome_pensao,
      matricula_pensao: dadosServidor.matricula_pensao,
      data_nascimento_pensao: dadosServidor.data_nascimento_pensao,
      data_falecimento_pensao: dadosServidor.data_falecimento_pensao,
      tipo_pensao: dadosServidor.tipo_pensao,
      valor_beneficio: dadosServidor.valor_beneficio,
      tipo_fundo: dadosServidor.tipo_fundo,
      tipo_vinculo: dadosServidor.tipo_vinculo,
      relacao_titular_pensao: dadosServidor.relacao_titular_pensao,
      orgao: dadosServidor.orgao,
      agenda: dadosServidor.agenda,
      oldStatus: self.oldStatus,
      id_censo: self.idCenso || '',
      id_tipo_alteracao: self.idTipoAlteracao || '',
      justificativa: self.justificativa || ''
    }).pipe(take(1)).toPromise();
    
    self.spinner.hide();
    await this.app.alert('Tudo certo!', 'Servidor atualizado com sucesso!', 'success');
    await self.ngOnInit();
}
  navigateTo(path){
    this.router.navigate([path],  { queryParams: { id: this.idServidor, idCidade: this.idCidade, id_matricula: this.idMatricula }});
  }
  navigateToTempos(tipo){
    this.router.navigate(['page/servidor/tempos'],  { queryParams: { id: this.idServidor, idCidade: this.idCidade, id_matricula: this.idMatricula, tipo: tipo }});
  }
  async iniciarAtendimento(){
    const self = this
    if (!self.idMatricula) {
      await self.app.alert('Erro', 'Selecione uma matrícula para iniciar o atendimento.', 'error')
      return
    }
    await this.apiCall.get(`servidor/atendimento/inicio?id_servidor=${self.servidor.id}&id_matricula=${self.idMatricula}&id_cidade=${self.idCidade}&inicio_atendimento=${moment().format('YYYY-MM-DD HH:mm:ss')}`).pipe(take(1)).toPromise()
    self.spinner.hide()
    await this.app.alert('Tudo certo!', 'atendimento iniciado!', 'success')
    await self.ngOnInit()
  }
  async reiniciarAtendimento(){
    const self = this
    if (!self.idMatricula) {
      await self.app.alert('Erro', 'Selecione uma matrícula para reiniciar o atendimento.', 'error')
      return
    }
    await this.apiCall.get(`servidor/atendimento/reinicio?id_servidor=${self.servidor.id}&id_matricula=${self.idMatricula}&id_cidade=${self.idCidade}`).pipe(take(1)).toPromise()
    self.spinner.hide()
    await this.app.alert('Tudo certo!', 'atendimento reiniciado!', 'success')
    await self.ngOnInit()
  }
  async finalizarAtendimento(){
    const self = this
    if (!self.idMatricula) {
      await self.app.alert('Erro', 'Selecione uma matrícula para finalizar o atendimento.', 'error')
      return
    }
    await this.apiCall.get(`servidor/atendimento/fim?id_servidor=${self.servidor.id}&id_matricula=${self.idMatricula}&id_cidade=${self.idCidade}&fim_atendimento=${moment().format('YYYY-MM-DD HH:mm:ss')}`).pipe(take(1)).toPromise()
    self.spinner.hide()
    await this.app.alert('Tudo certo!', 'atendimento finalizado!', 'success')
    await self.ngOnInit()
  }
  timer = null

  beautifulDate(data){
    return moment(data).format('HH[h]-mm[m]-ss[s do dia ]DD-MM-YYYY')
  }
  getYear(data){
    return moment(data).format('YYYY')
  }
  preparaData(data){
    return prepararDataParaApi(data)
  }
  getTotalDaysFromDateToToday(fromDate) {
    console.log('servidor.data_ingresso_servico_publico', fromDate);
    
    if (!moment(fromDate, 'DD/MM/YYYY', true).isValid()) {
      console.error('Invalid date format. Expected format: DD/MM/YYYY');
      return 0;
    }
    
    const today = moment();
    const fromDateMoment = moment(fromDate, 'DD/MM/YYYY');
    return today.diff(fromDateMoment, 'days');
  }
  validateQuotes(str){
    if(str){
      return str.replace("'", "\'");
    }else{
      return ''
    }
  }
}
